import React, { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import Switch from "react-switch";
import CurrencyInput from "react-currency-masked-input";
import { v4 as uuidv4 } from "uuid";
import { MultiSelect } from "primereact/multiselect";
import AgenciaService from "../../services/AgenciaService";
import AutenticacaoService from "../../services/AutenticacaoService";
import CarrinhoService from "../../services/CarrinhoService";
import LojaService from "../../services/LojaService";
import DestinatarioAssociadoService from "../../services/DestinatarioAssociadoService";
import GeografiaService from "../../services/GeografiaService";
import TagueamentoService from "../../services/TagueamentoService";
import ValidaCNPJ from "../../utils/ValidaCNPJ";
import ValidaCPF from "../../utils/ValidaCPF";
import validarEmail from "../../utils/ValidaEmail";
import validarTelefone from "../../utils/validarTelefone";
import CalculadoraModal from "../CalculadoraModal/CalculadoraModal";
import Input from "../FlexFreteInput/Input";
import Modal from "../FlexFreteModal/Modal";
import FlexSpinner from "../FlexFreteSpinner/FlexSpinner";
import { BtnSection, CalculadoraComplementarForm, FormStyle, GlobalFilterStyle } from "./style";
import { moneyMask } from "../../utils/Masks";
import DCeService from "../../services/DCeService";
import { DceWaiting } from "./style";
import {
  ModalContainerStyle,
  ModalContentStyle,
  BtnModalVoltarStyle,
  BtnModalSeguirStyle,
} from "../FlexFreteModal/style";

const geografiaService = new GeografiaService();
const agenciaService = new AgenciaService();
const validacaoDo = new ValidaCPF();
const validacaoPj = new ValidaCNPJ();
const authService = new AutenticacaoService();
const carrinhoService = new CarrinhoService();
const tagueamentoService = new TagueamentoService();
const destinatarioAssociadoService = new DestinatarioAssociadoService();
const lojaService = new LojaService();
const dceService = new DCeService();

function CalculadoraLogadoInfosComplementares({ redirect, edit }) {
  const usuario = authService.usuarioCorrente();
  const dispatch = useDispatch();

  let { freteCotacaoSelecionada, estadoDCeSalvo } = useSelector((state) => {
    return {
      ...state,
    };
  });

  const maxCaracteresNotaFiscal = 54;
  const maxCaracteresDeclaracaoEletronica = 54;
  const maxCaracteresComplementoEndereco = 20;
  const maxCacteresNumeroEndereco = 5;
  const maxCfop = 4;
  const cotacao = freteCotacaoSelecionada;

  const DCE_STATUS = {
    IDLE: "IDLE",
    GENERATING: "GENERATING",
    PENDENTE: "PENDENTE",
    AUTORIZADA: "AUTORIZADA",
    CONTINGENCIA: "CONTINGENCIA",
    ERROR: "ERROR",
  };
  const DCE_POLLING_INTERVAL_MS = 3000;

  const parseMoney = (str) => {
    if (!str) return 0;
    return (
      parseFloat(
        String(str)
          .replace(/[R$\s.]/g, "")
          .replace(",", ".")
      ) || 0
    );
  };

  const carrinhoInformacoes = edit || {};
  const [semNumero, setSemNumero] = useState(false);
  const numero = useRef();
  const [semNumeroOrigem, setSemNumeroOrigem] = useState(false);
  const numeroOrigem = useRef();
  const [city, setCity] = useState(false);
  const [cityOrigem, setCityOrigem] = useState(false);
  const valorEncomenda = localStorage.getItem("valorEncomenda");
  const valorEncomendaNumerico = parseFloat(valorEncomenda);
  const valorComparativo = !isNaN(valorEncomendaNumerico) ? valorEncomendaNumerico : 0;
  const [cfop, setNumeroCfop] = useState(carrinhoInformacoes?.notaFiscal?.cfop || "");
  const [telefoneMask, setTelefoneMask] = useState("(99)99999-9999");
  const [isCnpj, setIsCnpj] = useState(carrinhoInformacoes.isCnpj);
  const [sucesso, setSucesso] = useState({
    isSucesso: false,
    titulo: "",
    mensagem: "",
  });
  const loja = useSelector((state) => state.loja);
  const usarDadosUsuario = useSelector((state) => state.usarDadosUsuario);
  const [lojas, setLojas] = useState([]);
  const [lojaPadraoUuid, setLojaPadraoUuid] = useState(null);
  const [lojaSelectedUuid, setLojaSelectedUuid] = useState([]);

  const [request, setRequest] = useState({
    nome: carrinhoInformacoes?.destinatario?.nome,
    sobrenome: carrinhoInformacoes?.destinatario?.sobrenome,
    cpfCnpj: carrinhoInformacoes?.destinatario?.cpfCnpj,
    telefone: carrinhoInformacoes?.destinatario?.telefone,
    email: carrinhoInformacoes?.destinatario?.email,
    logradouro: "",
    numero:
      carrinhoInformacoes?.destinatario?.endereco?.numero?.substring(
        0,
        maxCacteresNumeroEndereco
      ) || "",
    numeroOrigem: carrinhoInformacoes?.remetente?.endereco.numero?.substring(
      0,
      maxCacteresNumeroEndereco
    ),
    cep: "",
    bairro: "",
    cidade: "",
    complemento:
      carrinhoInformacoes?.destinatario?.endereco?.complemento?.substring(
        0,
        maxCaracteresComplementoEndereco
      ) || "",
    complementoOrigem:
      carrinhoInformacoes?.remetente?.endereco?.complemento?.substring(
        0,
        maxCaracteresComplementoEndereco
      ) || "",
  });
  useEffect(() => {
    if (loja?.uuid && loja?.ativo && loja?.endereco?.cep === cotacao.cepOrigem) {
      setRequest((prevState) => ({
        ...prevState,
        numeroOrigem: loja?.endereco?.numero?.substring(0, maxCacteresNumeroEndereco),
        complementoOrigem: loja?.endereco?.complemento?.substring(
          0,
          maxCaracteresComplementoEndereco
        ),
      }));
    }
  }, [cotacao.cepOrigem, loja]);

  // ── RESTAURAR ESTADO DCe DO REDUX ────────────────────────────────────────────
  useEffect(() => {
    const raw = sessionStorage.getItem("dce-itens-salvos");
    if (raw) {
      sessionStorage.removeItem("dce-itens-salvos");
      setItensDCe(JSON.parse(raw));
      setShowDCe(true);
    }
    if (!estadoDCeSalvo) return;

    // Restaura todos os campos salvos antes de "Refazer cotação"
    setRequest((prev) => ({ ...prev, ...estadoDCeSalvo.request }));
    setLogradouro(estadoDCeSalvo.logradouro);
    setBairro(estadoDCeSalvo.bairro);
    setLogradouroOrigem(estadoDCeSalvo.logradouroOrigem);
    setBairroOrigem(estadoDCeSalvo.bairroOrigem);
    setCepEndereco(estadoDCeSalvo.cepEndereco);
    setCepEnderecoOrigem(estadoDCeSalvo.cepEnderecoOrigem);
    setIsCnpj(estadoDCeSalvo.isCnpj);
    setSemNumero(estadoDCeSalvo.semNumero);
    setSemNumeroOrigem(estadoDCeSalvo.semNumeroOrigem);
    setAgenciaSelect(estadoDCeSalvo.agenciaSelect);
    setItensDCe(estadoDCeSalvo.itensDCe);
    setShowDCe(true);
    setShowDeclaracaoEletronica(false);
    setShowNotaFiscal(false);

    // Limpa o estado salvo no Redux — foi consumido
    dispatch({ type: "LIMPAR_ESTADO_DCE" });

    // Rola até a seção DCe após render
    setTimeout(() => {
      document.querySelector(".dce-container")?.scrollIntoView({ behavior: "smooth" });
    }, 300);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // ────────────────────────────────────────────────────────────────────────────

  const toogleNotaDeclaracao = () => {
    if (!showNotaFiscal) {
      setNumeroNotaFiscal(null);
    }
  };

  const handleNotaFiscalChange = (event) => {
    if (event.target.checked) {
      setShowNotaFiscal(true);
      setShowDeclaracaoEletronica(false);
      setShowDCe(false);
    }
    toogleNotaDeclaracao();
  };

  const handleDeclaracaoEletronicaChange = (event) => {
    if (event.target.checked) {
      setShowDeclaracaoEletronica(true);
      setShowNotaFiscal(false);
      setShowDCe(false);
    }
    toogleNotaDeclaracao();
  };

  const [numeroNotaFiscal, setNumeroNotaFiscal] = useState(
    carrinhoInformacoes?.notaFiscal?.numeroDanfCte || []
  );
  const [chaveDce, setChaveDce] = useState(
    carrinhoInformacoes?.declaracaoEletronica?.chaveAcesso || ""
  );
  const [agenciaSelect, setAgenciaSelect] = useState(
    carrinhoInformacoes?.agencia ? carrinhoInformacoes.agencia : undefined
  );
  const [estados, setEstados] = useState([]);
  const [cidades, setCidades] = useState([]);
  const [cidadesDestino, setCidadesDestino] = useState([]);
  const [finalizarPagamento, setfinalizarPagamento] = useState(false);
  const [showDeclaracaoEletronica, setShowDeclaracaoEletronica] = useState(false);
  const [showNotaFiscal, setShowNotaFiscal] = useState(false);
  const [logradouro, setLogradouro] = useState();
  const [bairro, setBairro] = useState();
  const [logradouroOrigem, setLogradouroOrigem] = useState();
  const [bairroOrigem, setBairroOrigem] = useState();
  const [disabledEndereco, setDisabledEndereco] = useState({
    enderecoBairro: true,
    estadoMunicipio: true,
  });
  const [disabledEnderecoOrigem, setDisabledEnderecoOrigem] = useState({
    enderecoBairro: false,
    estadoMunicipio: false,
  });
  const [cepEndereco, setCepEndereco] = useState({
    cep: "",
    bairro: "",
    nomeCidade: "",
    cidade: undefined,
    logradouro: "",
    siglaUf: undefined,
    numero: "",
    complemento: "",
  });
  const [cepEnderecoOrigem, setCepEnderecoOrigem] = useState({
    cep: "",
    bairro: "",
    nomeCidade: "",
    cidade: undefined,
    logradouro: "",
    nomeUf: "",
    siglaUf: undefined,
    numero: "",
    complemento: "",
  });
  const [cepMismatchMessage, setCepMismatchMessage] = useState("");

  const setCfop = (event) => {
    event.target.setCustomValidity("");
    const inputValue = event.target.value;
    const filteredValue = inputValue?.replace(/\D/g, "");
    if (filteredValue.toString().length <= 4) {
      setNumeroCfop(filteredValue);
    }
  };

  const callbackModalSucesso = () => {
    if (sucesso.isWrong === false) {
      setSucesso({ isWrong: true });
    }
  };

  //States CPe
  const [showDCe, setShowDCe] = useState(false);
  const [itensDCe, setItensDCe] = useState([]);
  const [novoItem, setNovoItem] = useState({
    descricao: "",
    quantidade: "",
    valorUnitario: "",
  });
  const [editandoIndex, setEditandoIndex] = useState(null);
  const [dceStatus, setDceStatus] = useState(DCE_STATUS.IDLE);
  const [dceUuid, setDceUuid] = useState(null);
  const [dceXMotivo, setDceXMotivo] = useState("");
  const [showValueMismatchModal, setShowValueMismatchModal] = useState(false);
  const [dceComputedTotal, setDceComputedTotal] = useState(0);
  // Contador de tentativas recebido via polling — exibido como "Tentativa X de 3" durante retry no backend
  const [dceTentativaAtual, setDceTentativaAtual] = useState(null);
  const [dceTotalTentativas, setDceTotalTentativas] = useState(null);
  const pollingRef = useRef(null);
  const pollingAttemptsRef = useRef(0);

  const handleDCeChange = (event) => {
    if (event.target.checked) {
      setShowDCe(true);
      setShowDeclaracaoEletronica(false);
      setShowNotaFiscal(false);
    }
  };

  const handleDceChange = (event) => {
    event.target.setCustomValidity("");
    const inputValue = event.target.value;
    if (inputValue?.replace(/\D/g, "").length <= 44) {
      const filteredValue = inputValue?.replace(/[^\d\s]/g, "");
      const finalValue = filteredValue?.replace(/(\s)\s/g, "$1");
      setChaveDce(finalValue);
    }
  };

  const handleAddItem = () => {
    if (!novoItem.descricao) return;
    if (!(parseFloat(novoItem.quantidade) > 0)) return;
    setItensDCe([...itensDCe, novoItem]);
    setNovoItem({ descricao: "", quantidade: "", valorUnitario: "" });
  };

  const handleRemoveItem = (index) => {
    setItensDCe(itensDCe.filter((_, i) => i !== index));
  };

  const sanitizeValorUnitario = (value) => value.replace(/-/g, "");

  const handleEditItem = (index, field, value) => {
    const updated = [...itensDCe];
    const sanitizedFields = ["valorUnitario", "quantidade"];
    updated[index][field] = sanitizedFields.includes(field) ? sanitizeValorUnitario(value) : value;
    setItensDCe(updated);
  };
  const handleGerarDCe = (e) => {
    e.preventDefault();

    const faltando = validarDadosParaDCe();
    if (faltando.length > 0) {
      setErro({
        isWrong: true,
        mensagem: `Preencha os dados antes de gerar a DCe: ${faltando.join(", ")}.`,
      });
      return;
    }
    // ── Validações de formato (mesmas do submitInscricao) ──
    const erroFormato = validarFormatoParaDCe();
    if (erroFormato) {
      setErro({ isWrong: true, mensagem: erroFormato });
      return;
    }

    if (itensDCe.length === 0) {
      setErro({ isWrong: true, mensagem: "Adicione ao menos um item à DCe antes de gerar." });
      return;
    }

    const computedTotal = itensDCe.reduce(
      (acc, item) => acc + parseFloat(item.quantidade || 0) * parseMoney(item.valorUnitario),
      0
    );
    setDceComputedTotal(computedTotal);

    if (Math.abs(computedTotal - valorComparativo) > 0.01) {
      setShowValueMismatchModal(true);
      return;
    }

    _submitDCe();
  };

  const _submitDCe = () => {
    setDceStatus(DCE_STATUS.GENERATING);
    setDceXMotivo("");
    // Reseta contador de tentativas a cada nova emissão
    setDceTentativaAtual(null);
    setDceTotalTentativas(null);

    const remetente = setRemetente();

    const computedTotal = itensDCe.reduce(
      (acc, item) => acc + parseFloat(item.quantidade || 0) * parseMoney(item.valorUnitario),
      0
    );

    const payload = {
      identificadorCotacao: cotacao.uuid,
      identificadorTransportadora: cotacao.transportadora?.uuid,
      valorTotal: computedTotal,
      remetente: {
        tipoDocumento: remetente.cpfCnpj?.replace(/\D/g, "").length === 14 ? "CNPJ" : "CPF",
        documento: remetente.cpfCnpj?.replace(/\D/g, ""),
        nome: remetente.nome,
        email: remetente.email,
        endereco: {
          cep: remetente.endereco.cep,
          logradouro: remetente.endereco.logradouro,
          numero: remetente.endereco.numero,
          complemento: remetente.endereco.complemento || "",
          bairro: remetente.endereco.bairro,
          municipio: remetente.endereco.cidade,
          uf: remetente.endereco.estado,
        },
      },
      destinatario: {
        tipoDocumento: request.cpfCnpj?.replace(/\D/g, "").length === 14 ? "CNPJ" : "CPF",
        documento: request.cpfCnpj?.replace(/\D/g, ""),
        nome: request.sobrenome?.trim()
          ? `${request.nome} ${request.sobrenome.trim()}`
          : request.nome,
        email: request.email,
        endereco: {
          cep: cepEndereco.cep || cotacao.cepDestino,
          logradouro: logradouro || cepEndereco.logradouro,
          numero: request.numero || "S/N",
          complemento: request.complemento || "",
          bairro: bairro || cepEndereco.bairro,
          municipio: cepEndereco.nomeCidade || city,
          uf: cepEndereco.siglaUf,
        },
      },
      itens: itensDCe.map((item, index) => ({
        codigo: String(index + 1),
        descricao: item.descricao,
        ncm: item.ncm || null,
        quantidade: parseInt(item.quantidade, 10),
        valorUnitario: parseMoney(item.valorUnitario),
        valorTotal: parseFloat(item.quantidade || 0) * parseMoney(item.valorUnitario),
      })),
    };

    dceService.postCriarDCe(payload, (erro, data) => {
      if (erro) {
        setDceStatus(DCE_STATUS.ERROR);
        let mensagemErro = "Erro desconhecido";
        if (erro.response && erro.response.data) {
          mensagemErro = erro.response.data.message || JSON.stringify(erro.response.data);
        }

        setErro({ isWrong: true, mensagem: mensagemErro });
        return;
      }
      if (!data?.requestCode) {
        setDceStatus(DCE_STATUS.ERROR);
        setErro({ isWrong: true, mensagem: data?.message || "Erro ao criar DCe." });
        return;
      }
      setDceUuid(data.requestCode);
      setDceStatus(DCE_STATUS.PENDENTE);
      _startDCePolling(data.requestCode);
    });
  };

  const _startDCePolling = (requestCode) => {
    pollingAttemptsRef.current = 0;
    if (pollingRef.current) clearInterval(pollingRef.current);

    pollingRef.current = setInterval(() => {
      pollingAttemptsRef.current += 1;

      dceService.getDCeStatus(requestCode, (erro, data) => {
        if (erro) return;

        const status = data?.status;
        const motivo = data?.xmotivo || data?.xMotivo || data?.message || "Erro desconhecido.";

        if (status === "CONCLUIDO") {
          clearInterval(pollingRef.current);
          console.log("DCe CONCLUIDO, data completo:", data); // ← temporário
          setDceStatus(DCE_STATUS.AUTORIZADA);
          setDceUuid(requestCode);
        } else if (status === "CONTINGENCIA") {
          clearInterval(pollingRef.current);
          setDceStatus(DCE_STATUS.CONTINGENCIA);
          setDceUuid(requestCode);
        } else if (status === "FALHA") {
          clearInterval(pollingRef.current);
          setDceStatus(DCE_STATUS.ERROR);
          setDceXMotivo(motivo);
          // setErro({ isWrong: true, mensagem: motivo });
        }
        // Atualiza o contador de tentativas quando o backend estiver retentando (status PROCESSANDO)
        if (data?.tentativaAtual != null) {
          setDceTentativaAtual(data.tentativaAtual);
          setDceTotalTentativas(data.totalTentativas ?? 3);
        }
      });
    }, DCE_POLLING_INTERVAL_MS);
  };

  useEffect(() => {
    return () => {
      if (pollingRef.current) clearInterval(pollingRef.current);
    };
  }, []);
  const [agencias, setAgencias] = useState([]);
  const [erro, setErro] = useState({
    isWrong: false,
    titulo: "",
    mensagem: "",
    voltar: false,
    elementCallback: null,
  });

  const setNotaFiscal = (event) => {
    event.target.setCustomValidity("");
    const inputValue = event.target.value;
    if (inputValue?.replace(/\D/g, "").length <= 44) {
      const filteredValue = inputValue?.replace(/[^\d\s]/g, "");
      const finalValue = filteredValue?.replace(/(\s)\s/g, "$1");
      setNumeroNotaFiscal(finalValue);
    }
  };

  const [adicionado, setAdicionado] = useState({
    isAdd: false,
    titulo: "",
    mensagem: "",
    voltar: false,
  });

  const [processando, setProcessando] = useState(false);
  const [enviandoInformacoes, setEnviandoInformacoes] = useState(false);
  const [agenciaOk, setagenciaOk] = useState(false);
  const [dadosDestinatarios, setdadosDestinatarios] = useState(false);
  const [destinatarioEndereco, setdestinatarioEndereco] = useState(false);
  const [remetenteEndereco, setremetenteEndereco] = useState(false);
  const [buscarCarrinho, setBuscarCarrinho] = useState([]);
  useEffect(() => {
    carrinhoService.getCarrinho((erroCarinho, sucesso) => {
      if (erroCarinho) {
        if (
          erroCarinho.response.data.code === "NOT_FOUND" &&
          erroCarinho.response.data.message === "Nenhum carrinho ativo encontrado"
        ) {
          setBuscarCarrinho();
          return;
        }
        setErro({
          isWrong: true,
          mensagem: "Falha ao obter dados do carrinho",
        });
      }
      if (sucesso) {
        setBuscarCarrinho(sucesso);
        carrinhoService.setCarrinhoInfosParaCompra(sucesso);
        carrinhoService.setNumeroItensInfosParaCompra(sucesso.fretes.length);
      }
    });
  }, []);

  const history = useHistory();

  useEffect(() => {
    lojaService.obterLojasAtivas((erro, data) => {
      if (data) {
        setLojas(data.map((l) => ({ label: l.razaoSocial, value: l.uuid })));
        const padrao = data.find((l) => l.isLojaPadraoAssinante === true);
        setLojaPadraoUuid(padrao?.uuid || null);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const lojaPadraoAplicadaRef = useRef(false);

  useEffect(() => {
    if (lojas.length === 0 || lojaPadraoAplicadaRef.current) {
      return;
    }
    lojaPadraoAplicadaRef.current = true;
    setLojaSelectedUuid((prev) => {
      const prevValido = prev.filter((uuid) => lojas.some((o) => o.value === uuid));
      if (prevValido.length > 0) {
        return prevValido;
      }
      if (
        carrinhoInformacoes?.identificadorLoja &&
        lojas.some((o) => o.value === carrinhoInformacoes.identificadorLoja)
      ) {
        return [carrinhoInformacoes.identificadorLoja];
      }
      if (lojaPadraoUuid && lojas.some((o) => o.value === lojaPadraoUuid)) {
        return [lojaPadraoUuid];
      }
      if (loja?.uuid && lojas.some((o) => o.value === loja.uuid)) {
        return [loja.uuid];
      }
      return prevValido;
    });
  }, [lojas, loja, lojaPadraoUuid, carrinhoInformacoes?.identificadorLoja]);

  useEffect(() => {
    getCEP(cotacao.cepDestino);
    getCEPOrigem(cotacao.cepOrigem);
    geografiaService.obtemEstados((erroEstados, sucesso) => {
      if (erroEstados) {
        setErro({
          isWrong: true,
          mensagem:
            "Falha ao obter estados, entre em contato com o suporte ou tente novamente mais tarde",
        });
        return;
      }
      if (sucesso) {
        setEstados(sucesso);
      }
    });
    // TODO: esse useEffect deve ser usado apenas quando a pagina é carregada --> By Renan
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function removeAcento(text) {
    if (text) {
      text = text.replace(new RegExp("[ÁÀÂÃ]", "gi"), "a");
      text = text.replace(new RegExp("[ÉÈÊ]", "gi"), "e");
      text = text.replace(new RegExp("[ÍÌÎ]", "gi"), "i");
      text = text.replace(new RegExp("[ÓÒÔÕ]", "gi"), "o");
      text = text.replace(new RegExp("[ÚÙÛŨ]", "gi"), "u");
      text = text.replace(new RegExp("[Ç]", "gi"), "c");
      return text;
    }
    return text;
  }

  const getCidades = (event, tipo) => {
    let cidade;

    if (event.target) {
      const { value } = event.target;
      cidade = value;
    } else {
      cidade = event;
    }
    geografiaService.obtemMunicipios(cidade, (erroCidade, sucesso) => {
      if (erroCidade) {
        setErro({
          isWrong: true,
          mensagem:
            "Falha ao obter municipios, entre em contato com o suporte ou tente novamente mais tarde",
        });
      } else {
        if (tipo === "origem") {
          setCidades(sucesso);
        } else if (tipo === "destino") {
          setCidadesDestino(sucesso);
        }
      }
    });
  };

  useEffect(() => {
    if (finalizarPagamento && processando === false) {
      history.push("/carrinho");
    }
  }, [finalizarPagamento, history, processando]);

  const getCEP = (cep) => {
    if (!cep) {
      return;
    }
    geografiaService.buscaPorCEP(cep, (erroCep, sucesso) => {
      if (erroCep) {
        setErro({
          isWrong: true,
          mensagem: "CEP não localizado. Insira manualmente informações do endereço.",
        });
        return;
      }
      if (sucesso) {
        setCepEndereco({
          cep: sucesso.cep,
          bairro: sucesso.bairro,
          nomeCidade: sucesso.nomeCidade,
          cidade: sucesso.cidade,
          siglaUf: sucesso.siglaUf,
          logradouro: sucesso.logradouro,
          nomeUf: sucesso.nomeUf,
        });
        setLogradouro(sucesso.logradouro);
        setBairro(sucesso.bairro);
        setCity(sucesso.cidade);
        setDisabledEndereco({
          enderecoBairro:
            sucesso.logradouro && sucesso.bairro !== null && sucesso.bairro?.trim().length > 0,
          estadoMunicipio: true,
        });
      }
      if (!cepEndereco.nomeCidade) {
        getCidades(sucesso.siglaUf, "destino");
      }
    });
  };

  const getCEPOrigem = (cep) => {
    if (!cep) {
      return;
    }
    const enderecoUsuarioLogado = JSON.parse(localStorage.getItem("usuario-endereco"));

    let cepIgual = false;
    let uf = "";
    if (enderecoUsuarioLogado?.cep) {
      const cepUsuarioNumeros = enderecoUsuarioLogado.cep?.replace(/\D/g, "");
      cepIgual = cep === cepUsuarioNumeros;
      if ((cepIgual && !loja.ativo) || (loja?.uuid && loja?.ativo && loja?.endereco?.cep === cep)) {
        setCepEnderecoOrigem({
          cep: cep,
          bairro: loja?.ativo ? loja?.endereco.bairro : enderecoUsuarioLogado.bairro,
          nomeCidade: loja?.ativo ? loja?.endereco.nomeCidade : enderecoUsuarioLogado.nomeCidade,
          cidade: loja?.ativo ? loja?.endereco.cidade : enderecoUsuarioLogado.cidade,
          siglaUf: loja?.ativo ? loja?.endereco.estado : enderecoUsuarioLogado.estado,
          logradouro: loja?.ativo ? loja?.endereco.logradouro : enderecoUsuarioLogado.logradouro,
          nomeUf: loja?.ativo ? loja?.endereco.nomeUf : enderecoUsuarioLogado.nomeUf,
          complemento: loja?.ativo
            ? loja.endereco.complemento?.substring(0, maxCaracteresComplementoEndereco)
            : enderecoUsuarioLogado?.complemento?.substring(0, maxCaracteresComplementoEndereco),
          numero: loja?.ativo
            ? loja?.endereco.numero?.substring(0, maxCacteresNumeroEndereco)
            : enderecoUsuarioLogado?.numero?.substring(0, maxCacteresNumeroEndereco),
        });

        setRequest({
          ...request,
          complementoOrigem: loja?.ativo
            ? loja.endereco.complemento?.substring(0, maxCaracteresComplementoEndereco)
            : enderecoUsuarioLogado?.complemento?.substring(0, maxCaracteresComplementoEndereco),
          numeroOrigem: loja?.ativo
            ? loja?.endereco.numero?.substring(0, maxCacteresNumeroEndereco)
            : enderecoUsuarioLogado?.numero?.substring(0, maxCacteresNumeroEndereco),
        });

        setLogradouroOrigem(
          loja?.ativo ? loja?.endereco.logradouro : enderecoUsuarioLogado.logradouro
        );
        setBairroOrigem(loja?.ativo ? loja?.endereco.bairro : enderecoUsuarioLogado.bairro);
        setCityOrigem(loja?.ativo ? loja?.endereco.cidade : enderecoUsuarioLogado.cidade);
        uf = loja?.ativo ? loja?.endereco.estado : enderecoUsuarioLogado.estado;
      }
    }
    geografiaService.buscaPorCEP(cep, (erroCep, sucesso) => {
      if (erroCep) {
        setErro({
          isWrong: true,
          mensagem: "CEP não localizado. Insira manualmente informações do endereço.",
        });
        if (!cepIgual) return;
      }
      if (sucesso) {
        const dadosFiltrados = Object.entries(sucesso).reduce((acc, [key, value]) => {
          if (value !== null && value !== "" && !(Array.isArray(value) && value.length === 0)) {
            acc[key] = value;
          }
          return acc;
        }, {});

        const enderecoLoja = loja?.endereco;
        //deve considierar
        let dadosAtualizados = null;
        if (loja?.ativo && loja?.endereco?.cep === cep) {
          dadosAtualizados = { ...dadosFiltrados, ...enderecoLoja };
        } else {
          dadosAtualizados =
            cepIgual && !loja?.ativo ? { ...dadosFiltrados, ...enderecoUsuarioLogado } : sucesso;
        }
        setCepEnderecoOrigem({
          cep: dadosAtualizados.cep,
          bairro: dadosAtualizados.bairro,
          nomeCidade: dadosAtualizados.nomeCidade,
          cidade: dadosFiltrados.cidade,
          siglaUf: dadosFiltrados.siglaUf,
          logradouro: dadosAtualizados.logradouro,
          nomeUf: dadosFiltrados.nomeUf,
        });
        if (!logradouroOrigem) {
          setLogradouroOrigem(dadosAtualizados.logradouro);
        }
        if (!bairroOrigem) {
          setBairroOrigem(dadosAtualizados.bairro);
        }
        setCityOrigem(dadosAtualizados.cidade);
        setDisabledEnderecoOrigem({
          enderecoBairro:
            dadosFiltrados.logradouro?.trim()?.length > 0 &&
            dadosFiltrados.bairro?.trim()?.length > 0,
          estadoMunicipio: true,
        });
        uf = sucesso.siglaUf;
      }
      if (uf) {
        if (!cepEnderecoOrigem.nomeCidade) {
          getCidades(uf, "origem");
        }
      }
    });

    let cincoPrimeirosDigitosCep = cep?.substring(0, 5);
    agenciaService.obterAgenciasDeUmaTransportadora(
      cotacao.transportadora.uuid,
      cincoPrimeirosDigitosCep,
      (erroAgencia, sucesso) => {
        if (erroAgencia) {
          setErro({
            isWrong: true,
            mensagem: "Agência não localizada.",
          });
          return;
        }
        if (sucesso) {
          setAgencias(sucesso);
        }
      }
    );
  };

  const onChange = (event) => {
    const { name, value } = event.target;

    if (event._reactName === "onFocus" && event.target.name === "cpfCnpj") {
      event.target.setCustomValidity("Preencha este campo.");
      return;
    } else {
      event.target.setCustomValidity("");
    }

    if (event._reactName === "onFocus" && event.target.name === "telefone") {
      event.target.setCustomValidity("Preencha este campo.");
      return;
    } else {
      event.target.setCustomValidity("");
    }

    let req = request;
    req[name] = value;
    setRequest({ ...req });
  };

  const onChangeSemNumero = (event) => {
    setSemNumero(event.target.checked);
    if (event.target.checked) {
      numero.current.value = "S/N";
    } else {
      numero.current.value = "";
    }
  };

  const onChangeSemNumeroCepOrigem = (event) => {
    setSemNumeroOrigem(event.target.checked);
    if (event.target.checked) {
      numeroOrigem.current.value = "S/N";
    } else {
      numeroOrigem.current.value = "";
    }
  };

  const onChangeEndereco = (event) => {
    const { name, value } = event.target;
    if (event._reactName === "onFocus" && event.target.name === "cep") {
      event.target.setCustomValidity("Preencha este campo.");
    } else {
      event.target.setCustomValidity("");
    }
    let req = request;
    req[name] = value;
    setCepEndereco({ ...req });
  };

  const onChangeEnderecoCepOrigem = (event) => {
    const { name, value } = event.target;

    if (event._reactName === "onFocus" && event.target.name === "cep") {
      event.target.setCustomValidity("Preencha este campo.");
    } else {
      event.target.setCustomValidity("");
    }

    let req = request;
    req[name] = value;
    setCepEnderecoOrigem({ ...req });
  };

  const onChangeEnderecoLogradouro = (event) => {
    setLogradouro(event.target.value);
  };

  const onChangeEnderecoBairro = (event) => {
    setBairro(event.target.value);
  };

  const onChangeEnderecoLogradouroOrigem = (event) => {
    setLogradouroOrigem(event.target.value);
  };

  const onChangeEnderecoBairroOrigem = (event) => {
    setBairroOrigem(event.target.value);
  };

  const onBlur = (event) => {
    let cep = event.target.value;
    if (!cep.length) {
      return;
    }
    let formatedcep = cep?.replace(/[^0-9]/g, "");
    return getCEP(formatedcep);
  };

  const onBlurCepOrigem = (event) => {
    let cep = event.target.value;
    if (!cep.length) {
      return;
    }
    let formatedcep = cep?.replace(/[\D]/g, "");
    return getCEPOrigem(formatedcep);
  };
  const voltarListTransportadoras = () => {
    sessionStorage.setItem("dce-itens-salvos", JSON.stringify(itensDCe));
    window.location.href = "/calculadora";
  };

  const setRemetente = () => {
    const enderecoBase = {
      cep: cotacao.cepOrigem,
      logradouro: logradouroOrigem || cepEnderecoOrigem.logradouro,
      bairro: bairroOrigem || cepEnderecoOrigem.bairro,
      cidade: cepEnderecoOrigem.nomeCidade || cityOrigem,
      estado: cepEnderecoOrigem.siglaUf || cityOrigem,
    };

    const getNumero = (cep, lojaCep, lojaNumero, requestNumero) => {
      return cep === lojaCep ? lojaNumero : requestNumero || "S/N";
    };

    const getComplemento = (cep, lojaCep, lojaComplemento, requestComplemento) => {
      return (removeAcento(cep === lojaCep ? lojaComplemento : requestComplemento) || "").substring(
        0,
        maxCaracteresComplementoEndereco
      );
    };

    if (loja?.uuid && loja?.ativo && !usarDadosUsuario) {
      return {
        nome: usuario.name,
        sobrenome: usuario.sobrenome || "",
        cpfCnpj: loja?.cnpj,
        telefone: usuario.telefone,
        email: usuario.email,
        endereco: {
          ...enderecoBase,
          numero: getNumero(cotacao.cepOrigem, loja?.endereco?.cep, loja?.endereco?.numero, "S/N"),
          complemento: getComplemento(
            cotacao.cepOrigem,
            loja?.endereco?.cep,
            loja?.endereco?.complemento,
            request.complementoOrigem
          ),
        },
      };
    } else {
      return {
        nome: usuario.name,
        sobrenome: usuario.sobrenome,
        cpfCnpj: usuario.username,
        telefone: usuario.telefone,
        email: usuario.email,
        endereco: {
          ...enderecoBase,
          numero: getNumero(
            cotacao.cepOrigem,
            loja?.endereco?.cep,
            request.numeroOrigem,
            request.numeroOrigem
          ),
          complemento: getComplemento(
            cotacao.cepOrigem,
            loja?.endereco?.cep,
            request.complementoOrigem,
            request.complementoOrigem
          ),
        },
      };
    }
  };

  const submitInscricao = (event) => {
    const destinatario = {
      nome: request.nome,
      sobrenome: request.sobrenome,
      cpfCnpj: request.cpfCnpj,
      telefone: request.telefone,
      email: request.email,
      endereco: {
        cep: cepEndereco.cep,
        logradouro: logradouro,
        numero: request.numero || numero.current?.value || "",
        complemento: request.complemento,
        bairro: bairro,
        cidade: cepEndereco.nomeCidade || city,
        estado: cepEndereco.siglaUf,
      },
    };

    event.preventDefault();
    window.scrollTo(0, 0);
    setProcessando(true);

    let callback;

    if (event.nativeEvent.submitter.value === "Finalizar pagamento") {
      setfinalizarPagamento(false);
      callback = function finalizarPagamentoFrete() {
        setfinalizarPagamento(true);
      };
    } else {
      setfinalizarPagamento(false);
      callback = modalCarrinho;
    }

    let telToBeFormated = request.telefone || carrinhoInformacoes?.destinatario?.telefone;
    let formatedTel;
    if (telToBeFormated) {
      formatedTel = telToBeFormated.replace(/[\D]/g, "");
    }
    const resultTel = validarTelefone(formatedTel);
    if (!resultTel) {
      setErro({
        isWrong: true,
        mensagem: "Telefone inválido.",
      });
      erroFinalizarPagamento();
      setEnviandoInformacoes(false);
      return;
    }

    const emailParaSerValidado = request.email || carrinhoInformacoes?.destinatario?.email;
    const resultEmail = validarEmail(emailParaSerValidado);
    if (!resultEmail) {
      setErro({
        isWrong: true,
        mensagem: "E-mail inválido.",
      });
      erroFinalizarPagamento();
      setEnviandoInformacoes(false);
      return;
    }

    if (!request.sobrenome?.trim()) {
      setErro({
        isWrong: true,
        mensagem: "Sobrenome do destinatário é obrigatório.",
      });
      erroFinalizarPagamento();
      setEnviandoInformacoes(false);
      return;
    }

    const paraSerFormatado = request.cpfCnpj || carrinhoInformacoes?.destinatario?.cpfCnpj;

    if (!paraSerFormatado) {
      setErro({
        isWrong: true,
        mensagem: "CPF/CNPJ inválido.",
      });
      erroFinalizarPagamento();
      setEnviandoInformacoes(false);
      return;
    }

    let formated = paraSerFormatado.replace(/\D/g, "");

    if (!isCnpj) {
      const resultCpf = validacaoDo.cpf(formated);
      if (!resultCpf) {
        setErro({
          isWrong: true,
          mensagem: "CPF inválido.",
        });
        erroFinalizarPagamento();
        setEnviandoInformacoes(false);
        return;
      }
    } else {
      const resultCpf = validacaoPj.cnpj(formated);
      if (!resultCpf) {
        setErro({
          isWrong: true,
          mensagem: "CNPJ inválido.",
        });
        erroFinalizarPagamento();
        setEnviandoInformacoes(false);
        return;
      }
    }
    if (cotacao.transportadora?.agenciaObrigatoria && !agenciaSelect) {
      setErro({
        isWrong: true,
        mensagem: "Selecione uma agencia.",
      });
      erroFinalizarPagamento();
      setEnviandoInformacoes(false);
      return;
    }

    if (showNotaFiscal) {
      if (numeroNotaFiscal?.replace(/\D/g, "")?.length !== 44) {
        const element = document.getElementById("preenchimentoNotaFiscal");
        if (element) {
          element.setCustomValidity(
            "Este campo deve conter 44 algarismos e podem ser utilizados espaços entre os grupos de algarismos."
          );
          element.focus();
          element.reportValidity();
        }
        erroFinalizarPagamento();
        setEnviandoInformacoes(false);
        return;
      }
    }

    if (showDeclaracaoEletronica) {
      if (chaveDce?.replace(/\D/g, "")?.length !== 44) {
        const element = document.getElementById("preenchimentoDce");
        if (element) {
          element.setCustomValidity("A chave da DCE deve conter 44 algarismos.");
          element.focus();
          element.reportValidity();
        }
        erroFinalizarPagamento();
        setEnviandoInformacoes(false);
        return;
      }
    }

    let agenciaTipoStr = "";
    if (agenciaSelect) {
      let tipo = agenciaSelect.split(" ");
      agenciaTipoStr = tipo[tipo.length - 1];
    }

    const remetente = setRemetente();
    const calculadoraInfosComplementaresRequest = {
      carrinhoKey: uuidv4(),
      identificadorCotacao: cotacao.uuid,
      identificadorLoja: lojaSelectedUuid[0] || "",
      agencia: agenciaSelect,
      agenciaTipo: agenciaTipoStr,
      destinatario: {
        nome: request.nome,
        sobrenome: request.sobrenome,
        cpfCnpj: formated,
        isCnpj,
        telefone: formatedTel,
        email: request.email,
        endereco: {
          numero: !request.numero || semNumero === true ? "S/N" : request.numero,
          complemento: removeAcento(request.complemento)?.substring(
            0,
            maxCaracteresComplementoEndereco
          ),
          cep: cotacao.cepDestino,
          logradouro: logradouro ? logradouro : cepEndereco.logradouro,
          bairro: bairro ? bairro : cepEndereco.bairro,
          cidade: !cepEndereco.nomeCidade ? city : cepEndereco.nomeCidade,
          estado: !cepEndereco.siglaUf ? city : cepEndereco.siglaUf,
        },
      },
      remetente: remetente,
      notaFiscal: showNotaFiscal
        ? {
            valorNotaFiscal: Number(valorComparativo),
            numeroDanfCte: numeroNotaFiscal?.replace(/\D/g, ""),
            cfop: cfop.padStart(4, "0"),
          }
        : null,
      descricaoConteudo: {},
      infoCotacao: cotacao,
    };

    let finalObj = [];
    finalObj.push(calculadoraInfosComplementaresRequest);
    finalObj.forEach((i) => {
      if (i.agencia !== null || i.agencia !== "") {
        setagenciaOk(true);
      }

      if (
        (i.destinatario.nome !== null || i.destinatario.nome !== "") &&
        (i.destinatario.cpfCnpj !== null || i.destinatario.cpfCnpj !== "") &&
        (i.destinatario.email !== null || i.destinatario.email !== "") &&
        (i.destinatario.telefone !== null || i.destinatario.telefone !== "")
      ) {
        setdadosDestinatarios(true);
      }

      if (
        (i.destinatario.endereco.logradouro !== null ||
          i.destinatario.endereco.logradouro !== "") &&
        (i.destinatario.endereco.cep !== null || i.destinatario.endereco.cep !== "") &&
        (i.destinatario.endereco.cidade !== null || i.destinatario.endereco.cidade !== "") &&
        (i.destinatario.endereco.bairro !== null || i.destinatario.endereco.bairro !== "") &&
        (i.destinatario.endereco.estado !== null || i.destinatario.endereco.estado !== "") &&
        (i.destinatario.endereco.numero !== null || i.destinatario.endereco.numero !== "")
      ) {
        setdestinatarioEndereco(true);
      }

      if (
        (i.remetente.endereco.logradouro !== null || i.remetente.endereco.logradouro !== "") &&
        (i.remetente.endereco.cep !== null || i.remetente.endereco.cep !== "") &&
        (i.remetente.endereco.cidade !== null || i.remetente.endereco.cidade !== "") &&
        (i.remetente.endereco.bairro !== null || i.remetente.endereco.bairro !== "") &&
        (i.remetente.endereco.estado !== null || i.remetente.endereco.estado !== "") &&
        (i.remetente.endereco.numero !== null || i.remetente.endereco.numero !== "")
      ) {
        setremetenteEndereco(true);
      }
    });

    let finalArrayRequest = [];

    if (buscarCarrinho) {
      buscarCarrinho?.fretes.forEach((item) => {
        const fretes = {
          identificadorCotacao: item.identificadoCotacao,
          identificadorLoja: item.cotacao?.identificadorLoja || "",
          numeroPedidoUsuario: [authService.usuarioCorrente()?.identificadorAssinatura],
          destinatario: item.destinatario,
          remetente: item.remetente,
          conteudo: item.conteudo || null,
          agenciaEndereco: item.enderecoAgencia,
          agenciaTipo: item.agenciaTipo || "",
          notaFiscal: item.notaFiscal || null,
          sefazDceUuid: item.sefazDceUuid || null,
          declaracaoEletronica: item.declaracaoEletronica || null,
        };
        finalArrayRequest.push(fretes);
      });
    }
    const requestNewFrete = {
      identificadorCotacao: cotacao.uuid,
      acrescimo: cotacao.acrescimo ?? null,
      identificadorLoja: lojaSelectedUuid[0] || "",
      numeroPedidoUsuario: [authService.usuarioCorrente()?.identificadorAssinatura],
      agenciaEndereco: agenciaSelect,
      agenciaTipo: agenciaTipoStr,
      destinatario: {
        nome: request.nome,
        sobrenome: request.sobrenome,
        cpfCnpj: formated,
        isCnpj,
        telefone: formatedTel,
        email: request.email,
        endereco: {
          numero: !request.numero || semNumero === true ? "S/N" : request.numero,
          complemento: (removeAcento(request.complemento) || "").substring(
            0,
            maxCaracteresComplementoEndereco
          ),
          cep: cotacao.cepDestino,
          logradouro: logradouro ? logradouro : cepEndereco.logradouro,
          bairro: bairro ? bairro : cepEndereco.bairro,
          cidade: !cepEndereco.nomeCidade ? city : cepEndereco.nomeCidade,
          estado: !cepEndereco.siglaUf ? city : cepEndereco.siglaUf,
        },
      },
      remetente: remetente,
      notaFiscal: showNotaFiscal
        ? {
            numeroDanfCte: numeroNotaFiscal?.replace(/[^\d]/g, ""),
            valorNotaFiscal: Number(valorComparativo),
            cfop: cfop.padStart(4, "0"),
          }
        : null,
      declaracaoEletronica: showDeclaracaoEletronica
        ? { chaveAcesso: chaveDce?.replace(/\D/g, ""), valorDeclarado: Number(valorComparativo) }
        : null,
      sefazDceUuid:
        showDCe && (dceStatus === DCE_STATUS.AUTORIZADA || dceStatus === DCE_STATUS.CONTINGENCIA)
          ? dceUuid
          : null,
    };

    finalArrayRequest.push(requestNewFrete);
    const finalobjCarrinho = { fretes: finalArrayRequest };

    setProcessando(true);
    carrinhoService.postCriarEditarCarrinho(finalobjCarrinho, (erroCarrinho, sucesso) => {
      if (erroCarrinho) {
        setErro({
          isWrong: true,
          mensagem: erroCarrinho?.response?.data?.message || "Erro ao adicionar item ao carrinho.",
        });
        erroFinalizarPagamento();
        return;
      }
      if (sucesso) {
        tagueamentoService.eventoMarketingAdicionarAoCarrinho(cotacao, remetente, destinatario);
        carrinhoService.setNumeroItensInfosParaCompra(sucesso.fretes.length);
        setProcessando(false);
        if (edit) {
          callback();
          return;
        }
        callback();
      }
    });
  };

  const callbackModal = () => {
    if (erro.elementCallback !== null && typeof erro.elementCallback === "function") {
      erro.elementCallback();
    }

    if (erro.isWrong === true) {
      setErro({ isWrong: false });
    }
  };

  const callbackModalCalculadora = () => {
    if (adicionado.isAdd === true) {
      setAdicionado({ isAdd: false });
    }
  };

  const modalCarrinho = () => {
    setAdicionado({
      isAdd: true,
      mensagem: "Pronto! Seu frete foi adicionado ao carrinho.",
    });
  };
  const erroFinalizarPagamento = () => {
    setProcessando(false);
    setfinalizarPagamento(false);
  };

  // const showDeclaracaoConteudo = (e) => {
  //     setShowDeclaracao(e.target.checked);
  // }

  const onBlurTelefone = (e) => {
    const { value } = e.target;
    if (value[value.length - 1] === "_") {
      setTelefoneMask("(99)9999-9999");
    } else {
      setTelefoneMask("(99)99999-9999");
    }
  };
  const onFocusTelefone = () => {
    setTelefoneMask("(99)99999-9999");
  };

  const checkCpfOrCnpjInfos = async (cpfCnpj) => {
    if (!cpfCnpj) return;
    const formattedCpfCnpj = cpfCnpj.replace(/\D/g, "");
    console.log("Verificando CPF/CNPJ:", formattedCpfCnpj);

    const clearFields = () => {
      setCepMismatchMessage("");
      setRequest((prevState) => ({
        ...prevState,
        nome: "",
        sobrenome: "",
        cpfCnpj: formattedCpfCnpj,
        telefone: "",
        email: "",
        numero: "",
        complemento: "",
        cep: cotacao.cepDestino || prevState.cep,
        logradouro: cepEndereco.logradouro || "",
        bairro: cepEndereco.bairro || "",
        cidade: cepEndereco.nomeCidade || prevState.cidade || "",
        estado: cepEndereco.siglaUf || prevState.estado || "",
      }));
      setCepEndereco((prevState) => ({
        ...prevState,
        cep: cotacao.cepDestino || prevState.cep,
        logradouro: prevState.logradouro || "",
        bairro: prevState.bairro || "",
        nomeCidade: prevState.nomeCidade || "",
        siglaUf: prevState.siglaUf || "",
      }));
      setLogradouro(cepEndereco.logradouro || "");
      setBairro(cepEndereco.bairro || "");
      setCity(cepEndereco.nomeCidade || "");
      setSemNumero(false);
    };

    try {
      const recipient = await destinatarioAssociadoService.getRecipientByDocument(formattedCpfCnpj);
      if (recipient) {
        console.log("Destinatário encontrado:", recipient);
        const recipientCep = recipient.endereco?.cep?.replace(/\D/g, "");
        const quotedCep = cotacao.cepDestino?.replace(/\D/g, "");

        if (recipientCep !== quotedCep) {
          console.log("CEPs:", recipient.endereco?.cep, cotacao.cepDestino);
          setCepMismatchMessage(
            `Ainda não há endereço cadastrado para este cliente no CEP ${
              quotedCep || "desconhecido"
            }.`
          );
          console.log("Endereço do destinatário não corresponde ao CEP da cotação.");
        } else {
          setCepMismatchMessage("");
          console.log("Endereço do destinatário corresponde ao CEP da cotação.");
        }

        const commonData = {
          nome: recipient.nome || "",
          sobrenome: recipient.sobrenome || "",
          cpfCnpj: recipient.cpfCnpj || "",
          telefone: recipient.telefone || "",
          email: recipient.email || "",
        };

        const enderecoData =
          recipientCep === quotedCep
            ? {
                cep: recipient.endereco?.cep || cotacao.cepDestino || "",
                logradouro: recipient.endereco?.logradouro || cepEndereco.logradouro || "",
                bairro: recipient.endereco?.bairro || cepEndereco.bairro || "",
                cidade: recipient.endereco?.nomeCidade || cepEndereco.nomeCidade || "",
                estado: recipient.endereco?.estado || cepEndereco.siglaUf || "",
                complemento:
                  recipient.endereco?.complemento?.substring(0, maxCaracteresComplementoEndereco) ||
                  "",
                numero:
                  recipient.endereco?.numero === "S/N" ? "" : recipient.endereco?.numero || "",
              }
            : {
                cep: cotacao.cepDestino || "",
                logradouro: cepEndereco.logradouro || "",
                bairro: cepEndereco.bairro || "",
                cidade: cepEndereco.nomeCidade || "",
                estado: cepEndereco.siglaUf || "",
                complemento: "",
                numero: "",
              };

        setRequest((prevState) => ({
          ...prevState,
          ...commonData,
          ...enderecoData,
        }));

        const cepEnderecoData =
          recipientCep === quotedCep
            ? {
                cep: recipient.endereco?.cep || cotacao.cepDestino || "",
                logradouro: recipient.endereco?.logradouro || cepEndereco.logradouro || "",
                bairro: recipient.endereco?.bairro || cepEndereco.bairro || "",
                nomeCidade: recipient.endereco?.nomeCidade || cepEndereco.nomeCidade || "",
                siglaUf: recipient.endereco?.estado || cepEndereco.siglaUf || "",
              }
            : {
                cep: cotacao.cepDestino,
                logradouro: cepEndereco.logradouro || "",
                bairro: cepEndereco.bairro || "",
                nomeCidade: cepEndereco.nomeCidade || "",
                siglaUf: cepEndereco.siglaUf || "",
              };

        setCepEndereco((prevState) => ({
          ...prevState,
          ...cepEnderecoData,
        }));

        if (recipientCep === quotedCep) {
          setLogradouro(recipient.endereco?.logradouro || cepEndereco.logradouro || "");
          setBairro(recipient.endereco?.bairro || cepEndereco.bairro || "");
          setCity(recipient.endereco?.nomeCidade || cepEndereco.nomeCidade || "");
          setSemNumero(recipient.endereco?.numero === "S/N");
        } else {
          setLogradouro(cepEndereco.logradouro || "");
          setBairro(cepEndereco.bairro || "");
          setCity(cepEndereco.nomeCidade || "");
          setSemNumero(false);
        }
      } else {
        console.log("Nenhum destinatário encontrado para CPF/CNPJ:", formattedCpfCnpj);
        clearFields();
      }
    } catch (error) {
      console.log("Erro ao buscar destinatário:", error);
      clearFields();
    }
  };

  const validarDadosParaDCe = () => {
    const faltando = [];

    if (!request.cpfCnpj?.replace(/\D/g, "")) faltando.push("CPF/CNPJ do destinatário");
    if (!request.nome) faltando.push("Nome do destinatário");
    if (!request.sobrenome?.trim()) faltando.push("Sobrenome do destinatário");
    if (!request.email) faltando.push("E-mail do destinatário");
    if (!(logradouro || cepEndereco.logradouro)) faltando.push("Endereço do destinatário");
    if (!(bairro || cepEndereco.bairro)) faltando.push("Bairro do destinatário");
    if (!(cepEndereco.nomeCidade || city)) faltando.push("Cidade do destinatário");
    if (!cepEndereco.siglaUf) faltando.push("Estado do destinatário");
    if (!semNumero && !request.numero) faltando.push("Número do destinatário");

    if (!(logradouroOrigem || cepEnderecoOrigem.logradouro)) faltando.push("Endereço do remetente");
    if (!(bairroOrigem || cepEnderecoOrigem.bairro)) faltando.push("Bairro do remetente");
    if (!(cepEnderecoOrigem.nomeCidade || cityOrigem)) faltando.push("Cidade do remetente");
    if (!cepEnderecoOrigem.siglaUf) faltando.push("Estado do remetente");
    if (!semNumeroOrigem && !request.numeroOrigem) faltando.push("Número do remetente");

    return faltando;
  };

  const validarFormatoParaDCe = () => {
    // CPF/CNPJ do destinatário
    const docDestinatario = (request.cpfCnpj || "").replace(/\D/g, "");
    if (isCnpj) {
      if (!validacaoPj.cnpj(docDestinatario)) return "CNPJ do destinatário inválido.";
    } else {
      if (!validacaoDo.cpf(docDestinatario)) return "CPF do destinatário inválido.";
    }

    // E-mail do destinatário
    if (!validarEmail(request.email)) return "E-mail do destinatário inválido.";

    // Telefone do destinatário
    const telDestinatario = (request.telefone || "").replace(/\D/g, "");
    if (!validarTelefone(telDestinatario)) return "Telefone do destinatário inválido.";

    // CPF/CNPJ do remetente (vem do setRemetente)
    const remetente = setRemetente();
    const docRemetente = (remetente.cpfCnpj || "").replace(/\D/g, "");
    if (docRemetente.length === 14) {
      if (!validacaoPj.cnpj(docRemetente)) return "CNPJ do remetente inválido.";
    } else {
      if (!validacaoDo.cpf(docRemetente)) return "CPF do remetente inválido.";
    }

    return null; // tudo ok
  };

  const preencheuNotaFiscal = () => {
    return numeroNotaFiscal !== null && numeroNotaFiscal.length > 0 && showNotaFiscal;
  };

  const preencheuDeclaracaoEletronica = () => {
    return chaveDce !== null && chaveDce.length > 0 && showDeclaracaoEletronica;
  };

  // ── SALVAR ESTADO DCe NO REDUX (não mais no localStorage) ───────────────────
  const salvarEstadoParaVoltarDCe = () => {
    dispatch({
      type: "SALVAR_ESTADO_DCE",
      payload: {
        request,
        logradouro,
        bairro,
        logradouroOrigem,
        bairroOrigem,
        cepEndereco,
        cepEnderecoOrigem,
        isCnpj,
        semNumero,
        semNumeroOrigem,
        agenciaSelect,
        itensDCe,
        showDCe: true,
        showNotaFiscal: false,
      },
    });
  };
  // ────────────────────────────────────────────────────────────────────────────

  return (
    <>
      <GlobalFilterStyle />
      {enviandoInformacoes === true || processando === true ? <FlexSpinner /> : null}
      {erro.isWrong === true ? (
        <Modal
          callbackModal={callbackModal}
          visivel={true}
          titulo={erro.titulo}
          conteudo={erro.mensagem}
        />
      ) : null}

      {adicionado.isAdd === true ? (
        <CalculadoraModal
          callbackModalCalculadora={callbackModalCalculadora}
          visivel={true}
          titulo={adicionado.titulo}
          conteudo={adicionado.mensagem}
          agenciaOk={agenciaOk}
          dadosDestinatarios={dadosDestinatarios}
          destinatarioEndereco={destinatarioEndereco}
          remetenteEndereco={remetenteEndereco}
        />
      ) : null}

      {sucesso.isWrong === false ? (
        <Modal
          callbackModal={callbackModalSucesso}
          visivel={true}
          titulo={sucesso.titulo}
          conteudo={sucesso.mensagem}
        />
      ) : null}
      {showValueMismatchModal && (
        <div className="modal is-active">
          <div className="modal-background"></div>
          <div className="modal-content">
            <ModalContainerStyle>
              <ModalContentStyle>
                <div className="attention">
                  <ion-icon name="alert-circle"></ion-icon>
                </div>

                <p>Valor divergente</p>
                <p>
                  O valor composto da DCe (
                  {new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(
                    dceComputedTotal
                  )}
                  ) é diferente do valor informado na cotação (
                  {new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(
                    valorComparativo
                  )}
                  ). O que deseja fazer?
                </p>

                <BtnModalVoltarStyle
                  type="button"
                  onClick={() => {
                    salvarEstadoParaVoltarDCe();
                    setShowValueMismatchModal(false);
                    voltarListTransportadoras();
                  }}
                >
                  Refazer a cotação
                </BtnModalVoltarStyle>

                <BtnModalSeguirStyle type="button" onClick={() => setShowValueMismatchModal(false)}>
                  Editar a DCe
                </BtnModalSeguirStyle>
              </ModalContentStyle>
            </ModalContainerStyle>
          </div>
        </div>
      )}

      <FormStyle onSubmit={submitInscricao}>
        <CalculadoraComplementarForm>
          <div>
            <h2 className="form-title page-title">Dados do destinatário</h2>

            {cepMismatchMessage && (
              <div
                className="notification is-warning"
                style={{ marginTop: "10px", marginBottom: "10px" }}
              >
                <p>{cepMismatchMessage}</p>
              </div>
            )}

            <div
              className="section-half"
              style={{
                marginTop: "20px",
                marginBottom: "20px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <label style={{ display: "flex", alignItems: "center" }}>
                <span style={{ marginRight: "5px" }}>CPF</span>

                <Switch
                  onChange={(e) => {
                    setIsCnpj(!isCnpj);
                  }}
                  checked={isCnpj}
                  offColor="#08f"
                  onColor="#08f"
                  uncheckedIcon={
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100%",
                        fontSize: 15,
                        color: "orange",
                        paddingRight: 2,
                      }}
                    ></div>
                  }
                  checkedIcon={
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100%",
                        fontSize: 15,
                        color: "orange",
                        paddingRight: 2,
                      }}
                    ></div>
                  }
                />
                <span style={{ marginLeft: "5px" }}>CNPJ</span>
              </label>
            </div>

            <Input
              type="text"
              mascara={!isCnpj ? "999.999.999-99" : "99.999.999/9999-99"}
              name="cpfCnpj"
              label={!isCnpj ? "CPF*" : "CNPJ*"}
              value={request.cpfCnpj || ""}
              maxLength="18"
              required={true}
              onChange={onChange}
              onBlur={(e) => checkCpfOrCnpjInfos(e.target.value)}
              onSubmit={(e) => checkCpfOrCnpjInfos(e.target.value)}
              onKeyPress={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  checkCpfOrCnpjInfos(e.target.value);
                }
              }}
            />

            <div className="section-half" style={{ marginTop: "20px", marginBottom: "20px" }}>
              <Input
                type="text"
                name="nome"
                label="Nome*"
                value={request.nome || ""}
                required={true}
                onChange={onChange}
              />
              <Input
                type="text"
                name="sobrenome"
                label="Sobrenome*"
                value={request.sobrenome || ""}
                required={true}
                onChange={onChange}
              />
            </div>

            <hr />
            <div className="section-half" style={{ marginTop: "20px", marginBottom: "20px" }}>
              <Input
                type="email"
                name="email"
                label="E-mail*"
                value={request.email || ""}
                required={true}
                onChange={onChange}
              />
              <Input
                type="tel"
                mascara={telefoneMask}
                name="telefone"
                value={request.telefone || ""}
                label="Telefone*"
                required={true}
                onChange={onChange}
                onFocus={onFocusTelefone}
                onBlur={onBlurTelefone}
              />
            </div>
          </div>

          <div>
            <div className="section-half" style={{ marginTop: "20px", marginBottom: "20px" }}>
              <Input
                type="text"
                mascara="99999-999"
                name="cep"
                label="CEP*"
                defaultValue={cotacao.cepDestino}
                required={true}
                disabled={true}
                onBlur={onBlur}
              />
              <Input
                type="text"
                name="logradouro"
                label="Endereço*"
                value={logradouro}
                disabled={disabledEndereco.enderecoBairro === true}
                required={true}
                onChange={onChangeEnderecoLogradouro}
              />
            </div>

            <div className="section-half" style={{ marginTop: "20px", marginBottom: "20px" }}>
              <Input
                type="text"
                name="bairro"
                label="Bairro*"
                value={bairro}
                disabled={disabledEndereco.enderecoBairro === true}
                required={true}
                onChange={onChangeEnderecoBairro}
              />
              <div>
                <div className="field">
                  <label className="label">Número*</label>
                  <div className="control">
                    <input
                      className="input"
                      type="text"
                      maxlength={maxCacteresNumeroEndereco}
                      name="numero"
                      ref={numero}
                      disabled={semNumero}
                      value={request.numero || ""}
                      required={semNumero}
                      onChange={onChange}
                    />
                  </div>
                </div>
                <small style={{ textAlign: "left" }}>
                  <div className="field">
                    <div className="control">
                      <label style={{ fontWeight: "700", color: "#282828" }}>
                        <input type="checkbox" name="numero" onChange={onChangeSemNumero} /> Sem
                        número
                      </label>
                    </div>
                  </div>
                </small>
              </div>
            </div>

            <Input
              type="text"
              name="complemento"
              label="Complemento"
              maxLength={maxCaracteresComplementoEndereco}
              onChange={onChange}
              value={request.complemento || ""}
            />
            <p
              style={{
                textAlign: "right",
                fontSize: "0.85em",
                color:
                  (request.complemento || "").length > maxCaracteresComplementoEndereco
                    ? "#cc0000"
                    : "#666",
              }}
            >
              {(request.complemento || "").length}/{maxCaracteresComplementoEndereco}
            </p>
            {(request.complemento || "").length > maxCaracteresComplementoEndereco && (
              <p style={{ color: "#cc0000", fontSize: "0.85em" }}>
                O complemento será truncado para {maxCaracteresComplementoEndereco} caracteres ao
                salvar.
              </p>
            )}

            <div className="section-half" style={{ marginTop: "20px", marginBottom: "20px" }}>
              <div style={{ marginBottom: "1.5em" }}>
                <label className="label">Cidade*</label>
                <div className="select" style={{ width: "100%" }}>
                  <select
                    value={cepEndereco.cidade || undefined}
                    name="cidade"
                    style={{ width: "100%" }}
                    disabled={disabledEndereco.estadoMunicipio}
                    onChange={onChangeEndereco}
                  >
                    {disabledEndereco.estadoMunicipio ? (
                      <option key={cepEndereco.cidade || "default"} value={cepEndereco.cidade}>
                        {cepEndereco.nomeCidade}
                      </option>
                    ) : (
                      cidadesDestino.map((cidade, index) => (
                        <option key={cidade.uuid} value={cidade.uuid}>
                          {cidade.nome}
                        </option>
                      ))
                    )}
                  </select>
                </div>
              </div>
              <div style={{ marginBottom: "1.5em" }}>
                <label className="label">Estado*</label>
                <div className="select" style={{ width: "100%" }}>
                  <select
                    value={cepEndereco.siglaUf || undefined}
                    name="estado"
                    style={{ width: "100%" }}
                    disabled={disabledEndereco.estadoMunicipio}
                    onChange={getCidades}
                  >
                    {estados.map((estado, index) => {
                      return (
                        <option key={Math.random() + index} value={estado.nome}>
                          {estado.nomeExtenso} - {estado.nome}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>
            </div>
          </div>
        </CalculadoraComplementarForm>

        {cotacao.transportadora?.agenciaObrigatoria === true ? (
          <CalculadoraComplementarForm>
            <div>
              <h2 className="form-title page-title">Escolha onde despachar a encomenda*</h2>
              <div style={{ marginBottom: "1.5em" }}>
                <label className="label">Selecione um endereço</label>
                <div className="select" style={{ width: "100%" }}>
                  <select
                    value={agenciaSelect}
                    name="agenciaSelect"
                    style={{ width: "100%" }}
                    required={true}
                    onChange={(event) => {
                      setAgenciaSelect(event.target.value);
                    }}
                  >
                    <option value=""></option>
                    {agencias.map((agencia, index) => {
                      return (
                        <option key={Math.random() + index} value={agencia.uuid}>
                          {agencia.endereco.logradouro}, {agencia.endereco.bairro},{" "}
                          {agencia.endereco.cidade} - {agencia.uf} ({agencia.nickname}){" "}
                          {agencia.tipo}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>
            </div>
          </CalculadoraComplementarForm>
        ) : (
          ""
        )}

        <CalculadoraComplementarForm>
          <div>
            <h2 className="form-title page-title">Dados do remetente</h2>
            <div className="section-half" style={{ marginTop: "20px", marginBottom: "20px" }}>
              <Input
                type="text"
                mascara="99999-999"
                name="cep"
                label="CEP*"
                defaultValue={cotacao.cepOrigem}
                required={true}
                disabled={true}
                onBlur={onBlurCepOrigem}
              />
              <Input
                type="text"
                name="logradouro"
                label="Endereço*"
                value={logradouroOrigem}
                disabled={disabledEnderecoOrigem.enderecoBairro === true}
                required={true}
                onChange={onChangeEnderecoLogradouroOrigem}
              />
            </div>

            <div className="section-half" style={{ marginTop: "20px", marginBottom: "20px" }}>
              <Input
                type="text"
                name="bairro"
                label="Bairro*"
                value={bairroOrigem}
                disabled={disabledEnderecoOrigem.enderecoBairro === true}
                required={true}
                onChange={onChangeEnderecoBairroOrigem}
              />
              <div>
                <div className="field">
                  <label className="label">Número*</label>
                  <div className="control">
                    <input
                      className="input"
                      maxlength={maxCacteresNumeroEndereco}
                      type="text"
                      name="numeroOrigem"
                      ref={numeroOrigem}
                      value={request.numeroOrigem}
                      disabled={semNumeroOrigem === true}
                      required={semNumeroOrigem !== true}
                      onChange={onChange}
                    />
                  </div>
                </div>
                <small style={{ textAlign: "left" }}>
                  <div className="field">
                    <div className="control">
                      <label style={{ fontWeight: "700", color: "#282828" }}>
                        <input
                          type="checkbox"
                          name="numero"
                          onChange={onChangeSemNumeroCepOrigem}
                        />{" "}
                        Sem número
                      </label>
                    </div>
                  </div>
                </small>
              </div>
            </div>
            <Input
              type="text"
              name="complementoOrigem"
              maxLength={maxCaracteresComplementoEndereco}
              label="Complemento"
              onChange={onChange}
              value={request.complementoOrigem || ""}
            />
            <p
              style={{
                textAlign: "right",
                fontSize: "0.85em",
                color:
                  (request.complementoOrigem || "").length > maxCaracteresComplementoEndereco
                    ? "#cc0000"
                    : "#666",
              }}
            >
              {(request.complementoOrigem || "").length}/{maxCaracteresComplementoEndereco}
            </p>
            {(request.complementoOrigem || "").length > maxCaracteresComplementoEndereco && (
              <p style={{ color: "#cc0000", fontSize: "0.85em" }}>
                O complemento será truncado para {maxCaracteresComplementoEndereco} caracteres ao
                salvar.
              </p>
            )}
            <div className="section-half" style={{ marginTop: "20px", marginBottom: "20px" }}>
              <div style={{ marginBottom: "1.5em" }}>
                <label className="label">Cidade*</label>
                <div className="select" style={{ width: "100%" }}>
                  <select
                    value={cepEnderecoOrigem.cidade ? cepEnderecoOrigem.cidade : undefined}
                    name="cidade"
                    style={{ width: "100%" }}
                    disabled={disabledEnderecoOrigem.estadoMunicipio === true}
                    onChange={onChangeEnderecoCepOrigem}
                  >
                    {cidades.map((cidade, index) => {
                      return (
                        <option key={Math.random() + index} value={cidade.uuid}>
                          {cidade.nome}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>
              <div style={{ marginBottom: "1.5em" }}>
                <label className="label">Estado*</label>
                <div className="select" style={{ width: "100%" }}>
                  <select
                    value={cepEnderecoOrigem.siglaUf ? cepEnderecoOrigem.siglaUf : undefined}
                    name="estado"
                    style={{ width: "100%" }}
                    disabled={disabledEnderecoOrigem.estadoMunicipio === true ? true : false}
                    onChange={getCidades}
                  >
                    {estados.map((estado, index) => {
                      return (
                        <option key={Math.random() + index} value={estado.nome}>
                          {estado.nomeExtenso} - {estado.nome}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>
            </div>
          </div>
        </CalculadoraComplementarForm>

        {lojas.length > 0 && (
          <CalculadoraComplementarForm>
            <div>
              <h2 className="form-title page-title">Loja</h2>
              <div style={{ marginBottom: "1.5em" }}>
                <label className="label">Selecione a loja</label>
                <MultiSelect
                  value={lojaSelectedUuid}
                  options={lojas}
                  onChange={(e) => setLojaSelectedUuid(e.value.slice(-1))}
                  optionLabel="label"
                  optionValue="value"
                  placeholder="Nenhuma"
                  maxSelectedLabels={1}
                  selectedItemsLabel="{0} loja selecionada"
                  showSelectAll={false}
                  filter
                  filterPlaceholder="Pesquisar"
                  emptyMessage="Nenhuma loja encontrada"
                  emptyFilterMessage="Nenhuma loja encontrada para essa busca"
                  className="multiselect-custom"
                  panelClassName="custom-filter-panel"
                  style={{ width: "100%" }}
                  itemTemplate={(option) => (
                    <div
                      style={{
                        padding: "0.5rem 1rem",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: "300px",
                        fontSize: "1.55rem",
                      }}
                      title={option.label}
                    >
                      {option.label}
                    </div>
                  )}
                />
              </div>
            </div>
          </CalculadoraComplementarForm>
        )}

        <CalculadoraComplementarForm>
          <div>
            <h2 className="form-title page-title">Conte&uacute;do do frete</h2>
          </div>
          <p className="valores-declaracao">
            Valor da encomenda:{" "}
            <span>
              {new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(
                valorComparativo
              )}
            </span>
          </p>
          <p className="declaracao-pergunta">Como deseja declarar ?</p>

          <div className="declaracao">
            <div>
              <input
                className="radio"
                type="radio"
                name="tipoDeclaracao"
                onChange={handleNotaFiscalChange}
              />
              Apresentação da Nota Fiscal
            </div>

            {showNotaFiscal && (
              <div className="nota-fiscal-container">
                <div className="section-half nota-fiscal">
                  <Input
                    id="preenchimentoNotaFiscal"
                    label="Chave da NF (44 algarismos)"
                    value={numeroNotaFiscal}
                    style={{ marginRight: "0px" }}
                    type="text"
                    onChange={setNotaFiscal}
                    maxLength={maxCaracteresNotaFiscal}
                    required={true}
                  />
                  <p>{numeroNotaFiscal?.toString()?.replace(/[^\d]/g, "").length || 0}/44</p>
                </div>
                <div className="section-half nota-fiscal">
                  <Input
                    id="cfop"
                    label="CFOP"
                    value={cfop}
                    style={{ marginRight: "0px", maxWidth: "100px" }}
                    type="text"
                    onChange={setCfop}
                    maxLength={maxCfop}
                    required={true}
                  />
                  <p>{cfop?.toString()?.replace(/\D/g, "").length || 0}/4</p>
                </div>
              </div>
            )}

            <div>
              <input
                className="radio"
                type="radio"
                name="tipoDeclaracao"
                onChange={handleDeclaracaoEletronicaChange}
              />
              Declaração de Conteúdo Eletrônica
            </div>

            {showDeclaracaoEletronica && (
              <div className="nota-fiscal-container">
                <div className="section-half nota-fiscal">
                  <Input
                    id="preenchimentoDce"
                    label="Chave da DCE (44 algarismos)"
                    value={chaveDce}
                    style={{ marginRight: "0px" }}
                    type="text"
                    onChange={handleDceChange}
                    maxLength={maxCaracteresDeclaracaoEletronica}
                    required={true}
                  />
                  <p>{chaveDce?.toString()?.replace(/[^\d]/g, "").length || 0}/44</p>
                </div>
              </div>
            )}

            <div>
              <input
                className="radio"
                type="radio"
                name="tipoDeclaracao"
                checked={showDCe}
                onChange={handleDCeChange}
              />
              Gerar Declaração de Conte&uacute;do Eletr&ocirc;nica
            </div>

            {showDCe && (
              <div className="dce-container">
                <p className="dce-title">Itens declarados</p>

                <table className="dce-table">
                  <thead>
                    <tr>
                      <th>Descrição</th>
                      <th>Quantidade</th>
                      <th>Valor unitário</th>
                      <th>Valor total</th>
                      <th>Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    {itensDCe.map((item, index) => (
                      <tr key={index}>
                        {editandoIndex === index ? (
                          <>
                            <td>
                              <input
                                value={item.descricao}
                                onChange={(e) => handleEditItem(index, "descricao", e.target.value)}
                              />
                            </td>
                            <td>
                              <input
                                type="number"
                                min="1"
                                value={item.quantidade}
                                onKeyDown={(e) =>
                                  (e.key === "-" || e.key === "e") && e.preventDefault()
                                }
                                onChange={(e) =>
                                  handleEditItem(index, "quantidade", e.target.value)
                                }
                              />
                            </td>
                            <td>
                              <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                                <span>R$</span>
                                <CurrencyInput
                                  separator="."
                                  value={item.valorUnitario.replace(",", ".")}
                                  onChange={(e, valorNovo) =>
                                    handleEditItem(
                                      index,
                                      "valorUnitario",
                                      valorNovo.replace(".", ",")
                                    )
                                  }
                                />
                              </div>
                            </td>
                            <td>
                              {moneyMask(
                                (item.quantidade * parseMoney(item.valorUnitario)).toString()
                              )}
                            </td>
                            <td>
                              <button
                                className="dce-action salvar"
                                type="button"
                                onClick={() => setEditandoIndex(null)}
                              >
                                Salvar
                              </button>
                            </td>
                          </>
                        ) : (
                          <>
                            <td>{item.descricao}</td>
                            <td>{item.quantidade}</td>
                            <td>{moneyMask(parseMoney(item.valorUnitario).toFixed(2))}</td>
                            <td>
                              {moneyMask(
                                (item.quantidade * parseMoney(item.valorUnitario)).toString()
                              )}
                            </td>
                            <td>
                              <button
                                className="dce-action editar"
                                onClick={() => setEditandoIndex(index)}
                                type="button"
                              >
                                Editar
                              </button>
                              {" | "}
                              <button
                                className="dce-action excluir"
                                onClick={() => handleRemoveItem(index)}
                                type="button"
                              >
                                Excluir
                              </button>
                            </td>
                          </>
                        )}
                      </tr>
                    ))}

                    {/* Linha de adição de novo item */}
                    <tr>
                      <td>
                        <input
                          placeholder="Descrição"
                          value={novoItem.descricao}
                          onChange={(e) => setNovoItem({ ...novoItem, descricao: e.target.value })}
                        />
                      </td>
                      <td>
                        <input
                          placeholder="Qnt"
                          type="number"
                          min="1"
                          value={novoItem.quantidade}
                          onKeyDown={(e) => (e.key === "-" || e.key === "e") && e.preventDefault()}
                          onChange={(e) =>
                            setNovoItem({
                              ...novoItem,
                              quantidade: e.target.value.replace(/-/g, ""),
                            })
                          }
                        />
                      </td>
                      <td>
                        <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                          <span>R$</span>
                          <CurrencyInput
                            placeholder="0,00"
                            separator="."
                            value={novoItem.valorUnitario.replace(",", ".")}
                            onChange={(e, valorNovo) =>
                              setNovoItem({
                                ...novoItem,
                                valorUnitario: valorNovo.replace(".", ","),
                              })
                            }
                          />
                        </div>
                      </td>
                      <td>
                        <input
                          placeholder="Valor total"
                          value={moneyMask(
                            (
                              parseFloat(novoItem.quantidade || 0) *
                              parseMoney(novoItem.valorUnitario)
                            ).toFixed(2)
                          )}
                          readOnly
                        />
                      </td>
                      <td>
                        <button
                          className="dce-action adicionar"
                          type="button"
                          disabled={!novoItem.descricao || !(parseFloat(novoItem.quantidade) > 0)}
                          onClick={handleAddItem}
                        >
                          + Adicionar
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <div className="dce-gerar-btn-wrapper">
                  {dceStatus === DCE_STATUS.IDLE && (
                    <button
                      type="button"
                      className="dce-gerar-btn"
                      disabled={editandoIndex !== null}
                      onClick={handleGerarDCe}
                    >
                      Gerar DCe
                    </button>
                  )}
                </div>
                {(dceStatus === DCE_STATUS.GENERATING || dceStatus === DCE_STATUS.PENDENTE) && (
                  <DceWaiting>
                    <div>
                      <p className="dce-waiting-title">Gerando declaração eletrônica</p>
                      <p className="dce-waiting-sub">Aguardando autorização da SEFAZ</p>
                      {/* Exibe "Tentativa X de 3" apenas quando o backend está retentando após falha transiente */}
                      {dceTentativaAtual != null && (
                        <p className="dce-waiting-sub">
                          Tentativa {dceTentativaAtual} de {dceTotalTentativas}
                        </p>
                      )}
                    </div>
                    <div className="dce-dot-row">
                      <div className="dce-dot" />
                      <div className="dce-dot" />
                      <div className="dce-dot" />
                    </div>
                    <div className="dce-steps">
                      <div className="dce-step done">
                        <div className="dce-step-icon">✓</div>
                        <span>Dados enviados</span>
                      </div>
                      <div className="dce-step active">
                        <div className="dce-step-icon">↻</div>
                        <span>Processando na SEFAZ</span>
                      </div>
                      <div className="dce-step pending">
                        <div className="dce-step-icon">○</div>
                        <span>DCe autorizada</span>
                      </div>
                    </div>
                  </DceWaiting>
                )}
                {(dceStatus === DCE_STATUS.AUTORIZADA || dceStatus === DCE_STATUS.CONTINGENCIA) && (
                  <DceWaiting className="dce-success-block">
                    <div>
                      <p className="dce-waiting-title">
                        {dceStatus === DCE_STATUS.AUTORIZADA
                          ? "Declaração autorizada com sucesso"
                          : "Declaração emitida em contingência"}
                      </p>
                      <p className="dce-waiting-sub">
                        {dceStatus === DCE_STATUS.AUTORIZADA
                          ? "Sua DCe foi autorizada pela SEFAZ e já pode ser baixada."
                          : "A SEFAZ está indisponível no momento. Sua DCe foi emitida em contingência e será processada assim que o serviço voltar."}
                      </p>
                    </div>
                    <div className="dce-success-icon">✓</div>
                    <div className="dce-steps">
                      <div className="dce-step done">
                        <div className="dce-step-icon">✓</div>
                        <span>Dados enviados</span>
                      </div>
                      <div className="dce-step done">
                        <div className="dce-step-icon">✓</div>
                        <span>Processada na SEFAZ</span>
                      </div>
                      <div className="dce-step done">
                        <div className="dce-step-icon">✓</div>
                        <span>
                          {dceStatus === DCE_STATUS.AUTORIZADA
                            ? "DCe autorizada"
                            : "DCe em contingência"}
                        </span>
                      </div>
                    </div>
                  </DceWaiting>
                )}

                {dceStatus === DCE_STATUS.ERROR && (
                  <DceWaiting className="dce-error-block">
                    <div>
                      <p className="dce-waiting-title">Não foi possível gerar a declaração</p>
                      <p className="dce-waiting-sub">
                        {dceXMotivo ||
                          "Ocorreu um erro ao processar a DCe. Verifique os dados e tente novamente."}
                      </p>
                    </div>
                    <div className="dce-error-icon">!</div>
                    <div className="dce-steps">
                      <div className="dce-step done">
                        <div className="dce-step-icon">✓</div>
                        <span>Dados enviados</span>
                      </div>
                      <div className="dce-step error">
                        <div className="dce-step-icon">✕</div>
                        <span>Recusada pela SEFAZ</span>
                      </div>
                      <div className="dce-step pending">
                        <div className="dce-step-icon">○</div>
                        <span>DCe autorizada</span>
                      </div>
                    </div>
                    <button
                      type="button"
                      className="dce-gerar-btn"
                      onClick={() => {
                        setDceStatus(DCE_STATUS.IDLE);
                        setDceXMotivo("");
                      }}
                    >
                      Tentar novamente
                    </button>
                  </DceWaiting>
                )}
              </div>
            )}
          </div>
        </CalculadoraComplementarForm>

        <BtnSection>
          <div className="alterar-transportadora" onClick={voltarListTransportadoras}>
            <ion-icon name="arrow-back"></ion-icon>
            <input className="button alterar-transportadora" value="Alterar transportadora" />
          </div>
          <input
            type="submit"
            value="Adicionar ao Carrinho"
            className="button add-carrinho"
            disabled={
              (!preencheuDeclaracaoEletronica() && !preencheuNotaFiscal() && !showDCe) ||
              (showDCe &&
                dceStatus !== DCE_STATUS.AUTORIZADA &&
                dceStatus !== DCE_STATUS.CONTINGENCIA)
            }
          />

          <input
            type="submit"
            className="button finalizar-pagamento"
            value="Finalizar pagamento"
            disabled={
              (!preencheuDeclaracaoEletronica() && !preencheuNotaFiscal() && !showDCe) ||
              (showDCe &&
                dceStatus !== DCE_STATUS.AUTORIZADA &&
                dceStatus !== DCE_STATUS.CONTINGENCIA)
            }
          />
        </BtnSection>
      </FormStyle>
    </>
  );
}

export default CalculadoraLogadoInfosComplementares;
